import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { Notas } from '../../models/models';
import { FirebaseRequestsService } from '../../services/requests/firebase/firebase-requests.service';

@Component({
  selector: 'app-notas-cliente',
  templateUrl: './notas-cliente.component.html',
  styleUrls: ['./notas-cliente.component.scss'],
})
export class NotasClienteComponent implements OnInit {
  notasSubscription!: Subscription;
  @Input() clienteCpf: string;
  @Input() clienteSiglaMarca: string;
  @Input() notaType: 'ANOTACAO' | 'LEMBRETE';
  @Output() ficouSemLembretes: EventEmitter<boolean> = new EventEmitter();
  notas!: Notas;

  constructor(private fireReqs: FirebaseRequestsService) {}

  ngOnInit() {
    console.log(this.notaType, this.clienteCpf, this.clienteSiglaMarca);

    this.notasSubscription = this.fireReqs
      .getNotasCliente(this.clienteCpf, this.clienteSiglaMarca)
      .subscribe((notas) => {
        this.notas = notas;

        if (notas) {
          if (
            this.notas?.notas?.filter((notas) => !notas.concluido).length <= 0
          ) {
            this.ficouSemLembretes.emit(true);
          }
        }
      });
  }

  deleteNota(notaId: number) {
    this.fireReqs
      .deleteNota(this.clienteCpf, this.clienteSiglaMarca, notaId)
      .subscribe((res) => res);
  }

  concludeNota(notaId: number) {
    this.fireReqs
      .concludeNote(this.clienteCpf, this.clienteSiglaMarca, notaId)
      .subscribe((res) => res);
  }

  ngOnDestroy(): void {
    this.notasSubscription.unsubscribe();
  }
}
